import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
import { Country } from "country-state-city";
import Loader from "../../components/loaders/Loader";
import { reactIcons } from "../../utils/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EntityForm from "../../components/Forms/EntityForm";
import CustomFileInput from "../../components/CustomFileInput";
import BackButton from "../../components/BackButton";

const initialState = {
  type: "",
  name: "",
  RegistrationNumber: "",
  emailAddress: "",
  phoneNumber: "",
  website: "",
  address: "",
  dateOfIncorporation: null,
  mineProductionCapacity: "",
  efficiencyMetrics: "",
  certification1: [],
  certification2: [],
  ol: [],
  ecl: [],
  mineEfficiencyMetrics: ""
};

const AddMine = () => {
  const [step1, setStep1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState({});
  const [dialCode, setDialCode] = useState("91");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [countryName, setCountryName] = useState("India");
  const [cardImage, setCardImage] = useState("");
  const [cardImage1, setCardImage1] = useState("");
  const [apiData, setApiData] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { key } = location.state || {};
  const getData = async () => {
    try {
      if (!id) return;

      const res = await api.getUserList(id);
      if (res.status && res.data) {
        setApiData(res?.data);
        const OrganizationMeta = res?.data?.data?.OrganizationMeta?.[0];

        if (OrganizationMeta) {
          const baseUrl = "https://ventursa-api.codesfortomorrow.com/storage";
          setIsReadOnly(true);

          setForm((prev) => ({
            ...prev,
            mineProductionCapacity:
              OrganizationMeta.mineProductionCapacity || "",
            mineEfficiencyMetrics: OrganizationMeta.mineEfficiencyMetrics || "",
            certification1: (OrganizationMeta.mineCertification || [])
              .slice(0, 1)
              .map((url) => ({ name: url.split("/").pop(), url })),
            certification2: (OrganizationMeta.mineCertification || [])
              .slice(1)
              .map((url) => ({ name: url.split("/").pop(), url })),
            ol: (OrganizationMeta.mineOperationalLicense || []).map((url) => ({
              name: url.split("/").pop(),
              url
            })),
            ecl: (OrganizationMeta.mineEnvironmentalCompliance || []).map(
              (url) => ({
                name: url.split("/").pop(),
                url
              })
            )
          }));

          const cert1 = OrganizationMeta.mineCertification?.[0];
          const cert2 = OrganizationMeta.mineCertification?.[1];

          setCardImage(cert1 ? cert1 : "");
          setCardImage1(cert2 ? `${baseUrl}/${cert2}` : "");
        }
      } else {
        console.error("Error fetching data:", res.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
    // eslint-disable-next-line
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleStepComplete = (stepData) => {
    setForm({
      ...form,
      ...stepData
    });
    setStep1(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    let errors = {};

    if (!form.mineProductionCapacity) {
      errors.mineProductionCapacity = "Annual production capacity is required";
    }

    if (!form.certification1 || form.certification1.length === 0) {
      errors.certification1 = "Please upload at least one certification file";
    }
    if (!form.ol || form.ol.length === 0) {
      errors.ol = "Please upload at least one operational license";
    }
    if (!form.ecl || form.ecl.length === 0) {
      errors.ecl =
        "Please upload at least one environmental compliance license";
    }
    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        type: form.type,
        primaryContactName: form.primaryContactName,
        name: form.name,
        registrationNumber: form.RegistrationNumber,
        emailAddress: form.emailAddress,
        phoneNumber: `+${dialCode}${form.phoneNumber}`,
        website: form.website || "",
        address: form.address,
        dateOfIncorporation: form.dateOfIncorporation,
        dialCode: "+" + dialCode,
        country: countryName,
        countryOfIncorporation: form.countryOfIncorporation,
        mineProductionCapacity: form.mineProductionCapacity,
        efficiencyMetrics: form.efficiencyMetrics || "",
        certification1: cardImage || "",
        certification2: cardImage1 || "",
        documentationChecklist: {},
        beneficialOwners: [],
        complianceRiskAssessment: [],

        addedBy: "admin",

        organizationMeta: [
          {
            mineProductionCapacity: form?.mineProductionCapacity || "",
            mineEfficiencyMetrics: form?.mineEfficiencyMetrics,
            mineCertification: [
              ...form.certification1.map((f) => f.url),
              ...form.certification2.map((f) => f.url)
            ],
            mineOperationalLicense: form.ol.map((f) => f.url),
            mineEnvironmentalCompliance: form.ecl.map((f) => f.url)
          }
        ]
      };

      const res = await api.registerUser(payload);
      if (res.status === 200 || res.status === 201) {
        console.log("iddd", res.data.organizationId);
        toast.success("Mine Added Successfully");
        navigate(`/documentation-checklist/${res.data.id}`, {
          state: { key: "saurabh" }
        });
        localStorage.setItem("organizationId", res.data.OrganizationMeta.id);
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      } else {
        // toast.error("An error occurred while submitting the form");
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const countryValue = e.target.value;
    const matched = Country.getAllCountries().find(
      (c) => c.name.toLowerCase() === countryValue.toLowerCase()
    );
    if (matched) {
      setCountryName(matched.name);
      setDialCode(matched.phonecode);
    }
  };

  useEffect(() => {
    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);

  return (
    <div>
      <header className="flex items-center gap-2">
        <BackButton />
        <h4 className="">Add Mine</h4>
      </header>
      <div className="border mt-5 border-yellow-dark p-5 rounded-[10px]  shadow-2xl bg-white">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (key) {
              handleSubmit(e);
            } else if (id) {
              navigate(`/documentation-checklist/${id}`);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="relative">
            {!step1 ? (
              <div className="font-semibold text-black text-20">
                Organization Information
              </div>
            ) : (
              <div className="font-semibold text-black text-20">
                 Role-Specific Details
              </div>
            )}
            {!step1 ? (
              <EntityForm
                handleChange={handleChange}
                formError={formError}
                handleCountryChange={handleCountryChange}
                selectedCountry={selectedCountry}
                Country={Country}
                dialCode={dialCode}
                onStepComplete={handleStepComplete}
                form={apiData?.data}
                isReadOnly={isReadOnly}
              />
            ) : (
              <div className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 items-start mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Annual production capacity{" "}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter capacity"
                    autoComplete="off"
                    name="mineProductionCapacity"
                    onChange={handleChange}
                    // className="text-input text-black text-12 lg:text-14 border"
                    className={`text-input ${
                      isReadOnly ? "readonly-input" : ""
                    }`}
                    value={form.mineProductionCapacity}
                    readOnly={isReadOnly}
                  />
                  {formError.mineProductionCapacity && (
                    <div className="form-eror">
                      {formError.mineProductionCapacity}
                    </div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block text-black">
                    Efficiency metrics (if applicable)
                  </label>
                  <input
                    type="text"
                    placeholder="Enter efficiency metrics"
                    autoComplete="off"
                    name="mineEfficiencyMetrics"
                    onChange={handleChange}
                    value={form.mineEfficiencyMetrics}
                    // className="text-input text-black text-12 lg:text-14 border"
                    className={`text-input ${
                      isReadOnly ? "readonly-input" : ""
                    }`}
                    readOnly={isReadOnly}
                  />
                </div>

                <div>
                  <CustomFileInput
                    label="Certification 1"
                    allowedFormats=" PDF"
                    name="certification1"
                    defaultValue={form.certification1.map((f) => f.url)}
                    disabled={isReadOnly}
                    onChange={(urls) => {
                      setForm((prev) => ({
                        ...prev,
                        certification1: urls.map((url) => ({
                          name: url.split("/").pop(),
                          url
                        }))
                      }));
                      setFormError((prev) => ({ ...prev, certification1: "" }));
                    }}
                  />
                  {formError.certification1 && (
                    <div className="form-eror">{formError.certification1}</div>
                  )}
                </div>

                {/* <CustomFileInput
                  label="Certification 2"
                  allowedFormats=" PDF"
                  name="certification2"
                  defaultValue={form.certification2.map((f) => f.url)}
                  disabled={isReadOnly}
                  onChange={(urls) =>
                    setForm((prev) => ({
                      ...prev,
                      certification2: urls.map((url) => ({
                        name: url.split("/").pop(),
                        url
                      }))
                    }))
                  }
                /> */}

                <div>
                  <CustomFileInput
                    label="Operational License"
                    allowedFormats=" PDF"
                    name="ol"
                    defaultValue={form.ol.map((f) => f.url)}
                    disabled={isReadOnly}
                    onChange={(urls) => {
                      setForm((prev) => ({
                        ...prev,
                        ol: urls.map((url) => ({
                          name: url.split("/").pop(),
                          url: url
                        }))
                      }));
                      setFormError((prev) => ({ ...prev, ol: "" }));
                    }}
                  />
                  {formError.ol && (
                    <div className="form-eror">{formError.ol}</div>
                  )}
                </div>
                <div>
                  <CustomFileInput
                    label="Environmental Compliance License"
                    allowedFormats=" PDF"
                    name="ecl"
                    defaultValue={form.ecl.map((f) => f.url)}
                    disabled={isReadOnly}
                    onChange={(urls) => {
                      setForm((prev) => ({
                        ...prev,
                        ecl: urls.map((url) => ({
                          name: url.split("/").pop(),
                          url: url
                        }))
                      }));
                      setFormError((prev) => ({ ...prev, ecl: "" }));
                    }}
                  />
                  {formError.ecl && (
                    <div className="form-eror">{formError.ecl}</div>
                  )}
                </div>
              </div>
            )}
          </div>
          {!step1 ? (
            <div className="flex gap-2 mt-5 justify-end items-center">
              {/* Step 2 button is now inside the EntityForm component */}
            </div>
          ) : (
            <div className="flex gap-2 mt-5 justify-end items-center">
              <button
                type="button"
                onClick={() => setStep1(false)}
                className={`btn btn-danger `}
              >
                {reactIcons.arrowleft} Back
              </button>
              <button
                type="submit"
                // disabled={isLoading || !form.mineProductionCapacity}
                className={`btn btn-primary ${
                  isLoading || !form.mineProductionCapacity
                    ? "btn-primary opacity-50 disabled:pointer-events-none"
                    : undefined
                }`}
              >
                {isLoading ? <Loader /> : "Next"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddMine;
